import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingService } from "../../services/Landing_Services/landing.service";
import { Team } from "../../utilities/interfaces/CMS_Interfaces/team_interfaces/team.interface";

@Component({
  selector: "app-about",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./about.component.html",
  styleUrl: "./about.component.css",
})
export class AboutComponent implements OnInit {
  team: Team[] | null = null;
  aboutPage: any;

  constructor(private landingService: LandingService) {}

  ngOnInit(): void {
    this.landingService.getPageBySlug("about").subscribe({
      next: (page) => {
        this.aboutPage = page;
      },
      error: (err) => console.error("Error fetching about page:", err),
    });

    this.landingService.getTeams().subscribe({
      next: (teams) => {
        this.team = teams;
      },
      error: (err) => console.error("Error fetching teams:", err),
    });
  }
}
